import type React from 'react';
import type { SystemData } from '../../types/ChatWindow';

const SystemMessage: React.FC<{
  data: SystemData;
  textColor: string;
  windowColor: string;
}> = ({ data: { text }, textColor, windowColor }) => {
  return (
    <p className='system-message-container' style={{ color: textColor }}>
      <span
        className='system-message-line'
        style={{ backgroundColor: textColor }}
      />
      <span className='system-message' style={{ backgroundColor: windowColor }}>
        {text}
      </span>
    </p>
  );
};

export default SystemMessage;
